import apiClient from './api';
import type {
  WorkflowAnalysisResponse,
  CreateWorkflowRequest,
  CreateWorkflowResponse,
  WorkflowDto,
  TriggerNextStepResponse,
  WorkflowVorlageDto,
  CreateWorkflowVorlageRequest,
  UpdateWorkflowVorlageRequest,
  ExecuteWorkflowVorlageResponse,
} from '../types/api';

export const workflowService = {
  // KI-Analyse für Workflow-Vorschlag
  analyzeForWorkflow: async (ticketID: number, provider?: string): Promise<WorkflowAnalysisResponse> => {
    const response = await apiClient.post<WorkflowAnalysisResponse>('/workflow/analyze', {
      ticketID,
      provider,
    });
    return response.data;
  },

  // Workflow erstellen
  createWorkflow: async (request: CreateWorkflowRequest): Promise<CreateWorkflowResponse> => {
    const response = await apiClient.post<CreateWorkflowResponse>('/workflow/create', request);
    return response.data;
  },

  // Nächsten Schritt auslösen
  triggerNextStep: async (ticketID: number): Promise<TriggerNextStepResponse> => {
    const response = await apiClient.post<TriggerNextStepResponse>('/workflow/trigger-next', {
      ticketID,
    });
    return response.data;
  },

  // Alle Workflows abrufen
  getAll: async (): Promise<WorkflowDto[]> => {
    const response = await apiClient.get<WorkflowDto[]>('/workflow');
    return response.data;
  },

  // Einzelnen Workflow abrufen
  getById: async (id: number): Promise<WorkflowDto> => {
    const response = await apiClient.get<WorkflowDto>(`/workflow/${id}`);
    return response.data;
  },

  // ====== Workflow-Vorlagen (Templates) ======

  // Alle Vorlagen abrufen
  getAllVorlagen: async (): Promise<WorkflowVorlageDto[]> => {
    const response = await apiClient.get<WorkflowVorlageDto[]>('/workflowvorlage');
    return response.data;
  },

  // Einzelne Vorlage abrufen
  getVorlageById: async (id: number): Promise<WorkflowVorlageDto> => {
    const response = await apiClient.get<WorkflowVorlageDto>(`/workflowvorlage/${id}`);
    return response.data;
  },

  // Neue Vorlage erstellen
  createVorlage: async (request: CreateWorkflowVorlageRequest): Promise<{ vorlageId: number; message: string }> => {
    const response = await apiClient.post<{ vorlageId: number; message: string }>('/workflowvorlage', request);
    return response.data;
  },

  // Vorlage aktualisieren
  updateVorlage: async (id: number, request: UpdateWorkflowVorlageRequest): Promise<{ message: string }> => {
    const response = await apiClient.put<{ message: string }>(`/workflowvorlage/${id}`, request);
    return response.data;
  },

  // Vorlage ausführen (Workflow starten)
  executeVorlage: async (id: number, customName?: string): Promise<ExecuteWorkflowVorlageResponse> => {
    const response = await apiClient.post<ExecuteWorkflowVorlageResponse>(`/workflowvorlage/${id}/execute`, {
      vorlageID: id,
      customName,
    });
    return response.data;
  },

  // Vorlage löschen
  deleteVorlage: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.delete<{ message: string }>(`/workflowvorlage/${id}`);
    return response.data;
  },
};

export default workflowService;
